import { Box, Paper, Typography } from "@mui/material";
import { useDomesticMarketSpreadPriceContext } from "../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceContext";
import { deleteData } from "../../../lib/dashboard/actions";
import { mutate } from "swr";
import ShowFavoritesButton from "../../../components/favorite/ShowFavoritesButton";
import Favorites from "../../../components/favorite/Favorites";
import DomesticMarketSpreadPriceChart from "./DomesticMarketSpreadPriceChart";
import DomesticMarketSpreadPriceFavoriteProducerCard from "./DomesticMarketSpreadPriceFavoriteProducerCard";
import { useDomesticMarketSpreadPriceProducerContext } from "../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceProducerContext";
import ProducerForm from "./forms/producer/ProducerForm";
import CategoryForm from "./forms/category/CategoryForm";
import DomesticMarketSpreadPriceTab from "./DomesticMarketSpreadPriceTab";
import DomesticMarketSpreadPriceFavoriteCategoryCard from "./DomesticMarketSpreadPriceFavoriteCategoryCard";
import { useDomesticMarketSpreadPriceCategoryContext } from "../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceCategoryContext";

const DomesticMarketSpreadPrice = () => {
  const { favorites, isFavoritesModal, setIsFavoritesModal, selectedTab } =
    useDomesticMarketSpreadPriceContext();

  const {
    handleSelectedProducerFavorite,
    producerChartData,
    isProducerChartLoading,
  } = useDomesticMarketSpreadPriceProducerContext();

  const {
    handleSelectedCategoryFavorite,
    categoryChartData,
    isCategoryChartLoading,
  } = useDomesticMarketSpreadPriceCategoryContext();

  const handleDeleteFavorite = async (id, e) => {
    e.stopPropagation();
    const { status } = await deleteData(
      `/favorite/domestic-ratio/producer/${id}`
    );
    if (status === 200) await mutate("/favorite/domestic-ratio/producer");
  };

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      {/* header  */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          اسپرد قیمتی کالا
        </Typography>
        <ShowFavoritesButton onClick={() => setIsFavoritesModal(true)} />
      </Box>
      <Favorites
        isChartLoading={
          selectedTab === "producer"
            ? isProducerChartLoading
            : isCategoryChartLoading
        }
        isOpen={isFavoritesModal}
        handleClose={() => setIsFavoritesModal(false)}
        favorites={favorites}
        handleSelectedFavorite={
          selectedTab === "producer"
            ? handleSelectedProducerFavorite
            : handleSelectedCategoryFavorite
        }
        handleDeleteFavorite={handleDeleteFavorite}
        FavoriteCard={
          selectedTab === "producer"
            ? DomesticMarketSpreadPriceFavoriteProducerCard
            : DomesticMarketSpreadPriceFavoriteCategoryCard
        }
      />
      <DomesticMarketSpreadPriceTab />

      {/* form */}
      {selectedTab === "producer" ? <ProducerForm /> : <CategoryForm />}

      {/* chart  */}
      <DomesticMarketSpreadPriceChart
        chartData={
          selectedTab === "producer" ? producerChartData : categoryChartData
        }
      />
    </Paper>
  );
};

export default DomesticMarketSpreadPrice;
